import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { ExerciseFormViewEnum } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/exerciseForm"
import { ModelChrono } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/modelChrono"
import type {
  ExerciseFormikType,
  ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"

export function ExerciseChronoForm({
  formik,
  setCurrentView,
  className,
  ...props
}: {
  formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey>
  setCurrentView: (view: ExerciseFormViewEnum) => void
} & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-col", className)} {...props}>
      <div className="flex flex-col gap-2">
        <div className="mb-4 flex max-w-[90%] flex-col gap-4">
          <Text fontStyle="HS">{word("program.planning.create.exercise.addChrono.titleHeader")}</Text>
          <Text fontStyle="BS" className="text-textDefault-caption">
            {word("program.planning.create.exercise.addChrono.descriptionHeader")}
          </Text>
        </div>
      </div>
      <ModelChrono formik={formik} setCurrentView={setCurrentView} />
    </div>
  )
}
